import React, { useState, useCallback } from "react";
import { useDispatch } from "react-redux";
import { Button } from "semantic-ui-react";
import { ModalBuilder, Modal, Form, useFormState } from "@redriver/cinnamon";
import { getOrganisation, updateOrganisation } from "./actions";
import { checkValidOrganisationName } from "./actions";

const EditOrganisation = ({
  organisation,
  as: As = Button,
  onUpdated,
  ...props
}) => {
  const dispatch = useDispatch();
  const formState = useFormState();

  const [checkingName, setCheckingName] = useState(false);
  const [isValidName, setIsValidName] = useState(true);
  const [formValid, setFormValid] = useState(false);
  const [showErrors, setShowErrors] = useState(false);

  const setNameIsValidFromResponse = useCallback(
    (response) => {
      setIsValidName(
        !!response &&
          (!formState.errors.name || formState.errors.name.length == 0)
      );
    },
    [formState.errors]
  );

  return (
    <ModalBuilder
      withForm
      loadAction={getOrganisation}
      loadParams={organisation.id}
      submitAction={updateOrganisation}
      submitParams={organisation.id}
      onSubmitted={onUpdated}
      renderTrigger={(showModal) => <As onClick={showModal} {...props} />}
      renderModal={(modalProps, formProps) => (
        <Modal
          {...modalProps}
          header="Edit Organisation"
          submitLabel="Save"
          size="tiny"
        >
          <Form
            {...formProps}
            onValidated={(isValid) => setFormValid(isValid)}
            showErrors={showErrors}
          >
            {(fields, errors) => (
              <React.Fragment>
                <Form.Input
                  label="Name"
                  field="name"
                  fluid
                  required
                  showErrors={showErrors || (!isValidName && !!fields.name)}
                  customValidator={() => {
                    if (
                      formProps.value.name &&
                      formProps.value.name != organisation.name
                    ) {
                      setCheckingName(true);
                      dispatch(
                        checkValidOrganisationName(
                          formProps.value.name,
                          organisation.id
                        )
                      )
                        .then((result) => {
                          if (result.success && result.response != null) {
                            setNameIsValidFromResponse(result.response);
                          }
                        })
                        .finally(() => setCheckingName(false));
                    }
                  }}
                  customErrors={
                    !checkingName && !isValidName && !!fields.name
                      ? ["Duplicate organisation name, please choose another"]
                      : errors.name
                  }
                />
                <Form.Checkbox
                  field="enforceMfa"
                  label="Enforce multi-factor authentication for all users in this organisation?"
                />
              </React.Fragment>
            )}
          </Form>
        </Modal>
      )}
    />
  );
};

export default EditOrganisation;
